import { required, minLength, maxLength } from "vuelidate/lib/validators";

const lesseeTargetValidations = {
    newCompanyData: {
        companyName: {
            required,
        },
        companyNameNPWP: {
            required,
        },
        companyAddress: {
            required,
            minLength: minLength(3),
        },
        provinceName: {
            required,
        },
        citizenship: {
            required,
        },
        cityName: {
            required,
        },
        districtName: {
            required,
        },
        village: {
            required,
        },
        postalCode: {
            required,
            maxLength: maxLength(5),
        },
        companyAktaAddress: {
            required,
        },
        companyNpwp16: {
            required,
            minLength: minLength(16),
            maxLength: maxLength(16),
        },
        companyNpwp22: {
            minLength: minLength(22),
            maxLength: maxLength(22),
        },
        companyPhone: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(15),
        },
        source: {
            required,
        },
    },
    newLesseeData: {
        picName: {
            required,
        },
        picPhone: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(15),
        },
        picDivision: {
            required,
        },
        picPosition: {
            required,
        },
    },
}

export default lesseeTargetValidations


// WEBPACK FOOTER //
// ./src/components/RentAdjustment/Utils/lesseeTargetValidations.js